<script>
export default {
  name: 'sidebar-header'
}
</script>
<template>
</template>




// WEBPACK FOOTER //
// header.vue?60a095db